import { render, staticRenderFns } from "./BudgetBatchesTab.vue?vue&type=template&id=6291cdb2"
import script from "./BudgetBatchesTab.vue?vue&type=script&lang=ts"
export * from "./BudgetBatchesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports